import { render, staticRenderFns } from "./TicketContacts.vue?vue&type=template&id=3941767c&scoped=true"
import script from "./TicketContacts.vue?vue&type=script&lang=js"
export * from "./TicketContacts.vue?vue&type=script&lang=js"
import style0 from "./TicketContacts.vue?vue&type=style&index=0&id=3941767c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941767c",
  null
  
)

export default component.exports